import { get } from './http';

// Types sourced from https://github.com/ev-proddev/org-xapi (Go)
// Paths below are relative to that repo root (xapi/model/).

// ── Types ─────────────────────────────────────────────────────────────────────

/** @source org.go */
export type OrgPub = {
  orgId: number;
  name: string | null;
  orgKey: string | null;
  orgType: string | null;
  avatarAssetUuid: string | null;
  createdTime: string;
  modifiedTime: string;
  brandPageUrl: string | null;
  communityPageUrl: string | null;
  communityPageKey: string | null;
  orgImageUrl: string | null;
};

/** @source brandAffinity.go */
export type BrandAffinity = {
  fromOrgId: number;
  toOrgId: number;
  toOrgName: string;
  toOrgAvatarUrl: string | null;
  toOrgKey: string | null;
  factor: number;
  source: string;
  hidden: boolean;
  active: boolean;
  createdTime: string;
  modifiedTime: string;
  targeted: boolean;
};

// ── API ───────────────────────────────────────────────────────────────────────

export function getOrg(orgId: number): Promise<{ organizations: OrgPub[] }> {
  return get<{ organizations: OrgPub[] }>(`/xapi/organization/pub/v1/organization/${orgId}`);
}

export function getSimilarBrands(orgId: number): Promise<BrandAffinity[]> {
  return get<BrandAffinity[]>(`/xapi/organization/ext/v1/brand/affinity/list/${orgId}`);
}
